/* unplugin-vue-components disabled */import { render } from "./ClockRecord.vue?vue&type=template&id=2c8d06c0&scoped=true"
import script from "./ClockRecord.vue?vue&type=script&lang=js"
export * from "./ClockRecord.vue?vue&type=script&lang=js"

import "./ClockRecord.vue?vue&type=style&index=0&id=2c8d06c0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8d06c0"]])

export default __exports__